import { cn } from "@gymflow/helpers";
import React from "react";

import { Spinner } from "../../atoms";

export const UserMemberPaymentsCard = {
  Container: ({
    children,
    isLoading,
  }: {
    children: React.ReactNode;
    isLoading?: boolean;
  }) => (
    <div className="bg-gray-0 flex min-h-[9.5rem] min-w-[19rem] flex-1 flex-col items-center justify-center gap-3 rounded-2xl border border-gray-200 shadow-sm">
      {isLoading && <Spinner className="size-12" />}
      {!isLoading && children}
    </div>
  ),
  Header: ({ children }: { children: React.ReactNode }) => (
    <div className="flex h-14 w-full flex-row items-center justify-between p-4 pb-0">
      {children}
    </div>
  ),
  Footer: ({
    children,
    footerClassName,
  }: {
    children: React.ReactNode;
    footerClassName?: string;
  }) => (
    <div
      className={cn(
        "flex h-20 w-full flex-row items-center justify-between p-4 pt-0",
        footerClassName,
      )}
    >
      {children}
    </div>
  ),
};
